const SET_SEARCH_BAR_POS = 'SET_SEARCH_BAR_POS';
const SET_KEYWORD = 'SET_KEYWORD';
const SET_DETAIL_ACTIVE_SECTION = 'SET_DETAIL_ACTIVE_SECTION';
const SET_DETAIL_TARGET_SECTION_ID = 'SET_DETAIL_TARGET_SECTION_ID';
const SET_IS_MOBILE_VIEW = 'SET_IS_MOBILE_VIEW';

const state = {
	searchBarPos: 'page',
	keyword: '',
	detailActiveSection: 'product-description',
	detailTargetSectionId: '',
	isMobileView: false,
};

const getters = {
	searchBarPos: state => state.searchBarPos,
	keyword: state => state.keyword,
	detailActiveSection: state => state.detailActiveSection,
	detailTargetSectionId: state => state.detailTargetSectionId,
	isMobileView: state => state.isMobileView,
};

const mutations = {
	[SET_SEARCH_BAR_POS](state, position) {
		state.searchBarPos = position;
	},
	[SET_KEYWORD](state, value) {
		state.keyword = value;
	},
	[SET_DETAIL_ACTIVE_SECTION](state, value) {
		state.detailActiveSection = value;
	},
	[SET_DETAIL_TARGET_SECTION_ID](state, value) {
		state.detailTargetSectionId = value;
	},
	[SET_IS_MOBILE_VIEW](state, value) {
		state.isMobileView = value;
	},
};

const actions = {
	setSearchBarPos({ commit }, value) {
		const position = value ? 'navbar' : 'page';
		commit(SET_SEARCH_BAR_POS, position);
	},
	setKeyword({ commit }, value) {
		commit(SET_KEYWORD, value);
	},
	setDetailActiveSection({ commit }, value) {
		commit(SET_DETAIL_ACTIVE_SECTION, value);
	},
	setDetailTargetSectionId({ commit }, value) {
		commit(SET_DETAIL_TARGET_SECTION_ID, value);
	},
	setIsMobileView({ commit }, value) {
		commit(SET_IS_MOBILE_VIEW, value);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
